import React, {Component} from 'react';
import './Sidebar.css'
import {NavLink, useLocation} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useState} from "react";
import logo from '../../assets/images/logo-simple.png'

import {css} from "@emotion/css";
import {SidebarItemsType, sideBarListItemsClerk} from "./SideBarItems";
import {useAuthState} from "../../context/AuthContext";

const SidebarComponent = () => {

    const location = useLocation();

    const {role: roles} = useAuthState();

    function checkIsSameAddress(route) {
        return location.pathname === route
    }

    function checkHaveSameAddress(route) {
        return location.pathname.search(route) >= 0

    }

//
    const [openModal, setOpenModal] = useState(false)
    const changeModalState = () => {
        setOpenModal(!openModal)
    }

    document.addEventListener("click", function (evt) {
        const modalClickButton = document.getElementById("modalClickButton");
        let targetElement = evt.target; // clicked element
        do {
            if (targetElement === modalClickButton) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);
        setOpenModal(false)
    });

    //

    function getSidebarItem(item, index) {
        return (
            item.type === SidebarItemsType.COLLAPSE ?
                <Accordion
                    className={checkHaveSameAddress(item.info.globalUrl) ? 'activeChild' : 'deActiveChild'}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                        <section className={item.info.icon}/>
                        <span
                            className="sidebar-collapse-item-title">{item.info.name}</span>
                    </AccordionSummary>
                    <AccordionDetails>

                        {item.child.map((item, index) => {
                            return <ul>
                                <li key={index}
                                    className={`sidebar-collapse-item-child ${checkIsSameAddress(item.info.globalUrl) ?
                                        "sidebar-collapse-item-child-active" :
                                        ""}`}>
                                    <div className={"w-100"}>
                                        <NavLink
                                            className={css`width: 100% !important;`}
                                            to={item.info.url}>
                                            <span className="w-100">{item.info.name}</span>
                                        </NavLink>
                                    </div>
                                </li>
                            </ul>
                        })}

                    </AccordionDetails>
                </Accordion>
                : item.type === SidebarItemsType.SIMPLE_ITEM ?
                    <ul>
                        <li key={index}
                            className={`sidebar-simple-item 
                                                ${checkIsSameAddress(item.info.globalUrl) ? "sidebar-simple-item-active " : ""}`}>
                            <NavLink to={item.info.url}>
                                <div id="itemIcon" className={item.info.icon}/>
                                <span>{item.info.name}</span>
                            </NavLink>
                        </li>
                    </ul> :
                    item.type === SidebarItemsType.HEADER_ITEM ?
                        <li className="sidebar-header-item">
                            <span>{item.info}</span>
                        </li>
                        :
                        <section className={
                            css`margin: 8px 10px 16px 10px;
                              color: var(--color-variant);`}>
                            ---404---
                        </section>
        )
    }

    return (
        <div className="sidebar-content" style={{direction: "ltr"}}>
            <section className="w-100" style={{direction: "rtl"}}>
                <div className="sidebar-wrapper">
                    <div className="hero-content">
                        <img src={logo} className={`logoStylesheet`} alt="خبرگزاری آوای پرران"/>
                        <span className="hero-title">خبرگزاری<br/>آوای پرران</span>
                    </div>
                    <ul id='sideBarContainer'>
                        {sideBarListItemsClerk.map((item, index) => {
                            if (item.type === SidebarItemsType.HEADER_ITEM) {
                                let canAddIt = false
                                if (item.accessRole && item.accessRole.length > 0) {

                                    item.accessRole.map((itemRole) => {
                                        if (roles.includes(itemRole)) {
                                            canAddIt = true
                                        }
                                    })

                                } else
                                    canAddIt = true

                                if (canAddIt)
                                    return getSidebarItem(item, index);
                            } else if (item.info.accessRole.length === 0) {
                                return getSidebarItem(item, index)
                            } else return roles.map(role => {
                                if (item.info.accessRole.includes(role)) {
                                    return getSidebarItem(item, index);
                                }
                            })
                        })}
                    </ul>
                </div>
            </section>

        </div>)
}

export default SidebarComponent;